<template>
  <v-form>
    <v-container>
      <v-layout row wrap>
        <v-flex
          xs12
          s12
          md4
        >
          <v-text-field
            v-model="libro.titulo"
            :counter="100"
            label="Título del libro"
            required
          ></v-text-field>
        </v-flex>

        <v-flex
          xs12
          s12
          md4
        >
          <v-combobox
          v-model="libro.editorial"
          :items="editoriales"
          item-text = "nombre"
          item-value = "id"
          clear-icon = '$vuetify.icons.clear'
          label="Seleccione la editorial del libro"
          required
          ></v-combobox>
        </v-flex>

        <v-flex
          xs12
          s12
          md4
        >
         <v-combobox
          v-model="libro.categoria"
          :items="categorias"
          item-text = "nombre_categoria"
          item-value = "id"
          clear-icon = '$vuetify.icons.clear'
          label="Seleccione la categoría del libro"
          required
          ></v-combobox>
        </v-flex>
        <v-layout row wrap>
            <v-flex
              xs12
              s12
              md12
            >
            <v-card>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">Autor(es) del libro</h3>
                    <v-layout row wrap>
                      <v-flex xs12 s12 md10>
                        <v-combobox
                          v-model="comboAutor"
                          :items="autores"
                          item-text = "nombre"
                          item-value = "id"
                          clear-icon = '$vuetify.icons.clear'
                          label="Seleccione el autor del libro que desea agregar"
                        ></v-combobox>
                        </v-flex>
                        <v-flex xs12 s12 md2>
                          <v-btn fab small dark color="indigo" @click="addAutor(comboAutor)">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 s12 md12>
                            <v-data-table :headers="computedHeadersAutores" :items="autoresLibro" :search="searchAutores" class="elevation-1">
                              <template v-slot:items="props">
                                <td>{{ props.item.nombres }}</td>
                                <td class="justify-center layout px-0">
                                  <v-icon medium @click="deleteAutor(props.item)">delete</v-icon>
                                </td>
                              </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                  </div>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-layout row wrap>
            <v-flex
              xs12
              s12
              md12
            >
            <v-card>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">Detalle de libros en bodega</h3>
                    <v-layout row wrap>
                      <v-flex xs12 s12 md1 style="margin-right:5px;">
                        <v-text-field
                            v-model="libro.isbn"
                            :counter="13"
                            label="ISBN"
                            required
                          ></v-text-field>
                        </v-flex>
                      <v-flex xs12 s12 md2 style="margin-right:5px;">
                        <v-text-field
                            v-model="libro.codigo_inventario"
                            :counter="30"
                            label="Código inventario"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 s12 md2 style="margin-right:5px;">
                        <v-combobox
                          :items="ediciones"
                          v-model="libro.edicion"
                          item-text = "edicion"
                          item-value = "edicion"
                          clear-icon = '$vuetify.icons.clear'
                          label="Seleccione la edición"
                        ></v-combobox>
                        </v-flex>
                        <v-flex xs12 s12 md2 style="margin-right:5px;">
                        <v-combobox
                          :items="anios"
                          v-model="libro.anio"
                          item-text = "anio"
                          item-value = "anio"
                          clear-icon = '$vuetify.icons.clear'
                          label="Seleccione el año de publicación"
                        ></v-combobox>
                        </v-flex>
                        <v-flex xs12 s12 md2 style="margin-right:5px;">
                        <v-text-field
                            v-model="libro.existencia"
                            :counter="3"
                            label="Existencia"
                            type="number"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 s12 md2>
                          <v-btn fab small dark color="indigo" @click="addDetalleLibro()">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 s12 md12>
                            <v-data-table
                              :headers="headersDetalle"
                              :items="librosDetalle"
                              class="elevation-1"
                            >
                            <template v-slot:items="props">
                                <td>{{ props.item.isbn }}</td>
                                <td>{{ props.item.codigo_inventario }}</td>
                                <td>{{ props.item.edicion }}</td>
                                <td>{{ props.item.anio }}</td>
                                <td>{{ props.item.existencia }}</td>
                                <td class="justify-center layout px-0">
                                  <v-icon medium @click="deleteDetail(props.item)">delete</v-icon>
                                </td>
                              </template>
                        </v-data-table>
                        </v-flex>
                    </v-layout>
                  </div>
                </v-card-title>
              </v-card>
            </v-flex>
            </v-layout>
          </v-layout>
      </v-layout>
      <v-layout row>
        <v-flex xs12 sm12 >
          <v-card>
            <v-card-actions>
              <v-btn flat color="red" @click="goBack()">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn style="color: white;" color="green" @click="createLibro()">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar v-model="snackbar" :timeout="timeout" :color="color">
        {{ text }}
        <v-btn color="black" text @click="snackbar=false">Cerrar</v-btn>
      </v-snackbar>
    </v-container>
  </v-form>

  
</template>


<script>
//Flujo de funcionamiento, el usuario ingresa los datos del libro seleccionando autores, categoría, etc, 
//luego agrega al listado la cantidad y edición con la que cuentan del libro y luego guarda
import { debuglog } from "util";
import Vue from "vue";
export default {
  data: () => ({
      loading: false,
      nackbar: false,
      text: "",
      timeout: 5000,
      color: "error",
      editoriales:[],
      //base_url: "http://localhost:8000", //LOCAL
      base_url: "", //SERVER
      categorias:[],
      comboAutor:"",
      autores:[],
      edicion:[],
      searchAutores: "",
      anios:[],
      libro:{
        isbn:"",
        codigo_inventario:"",
        titulo:"",
        existencia: "",
        editorial:"",
        edicion:"",
        categoria:"",
        anio:"",
      },
      autoresLibro:[],
      librosDetalle:[],
      ediciones:[
        {edicion:"1era Edición"},
        {edicion:"2da Edición"},
        {edicion:"3ra Edición"},
        {edicion:"4ta Edición"},
        {edicion:"5ta Edición"},
        {edicion:"6ta Edición"},
        {edicion:"7ma Edición"},
        {edicion:"8va Edición"},
        {edicion:"9na Edición"},
        {edicion:"10a Edición"},
        {edicion:"11ra Edición"},
        {edicion:"12da Edición"},
        {edicion:"13ra Edición"},
      ],
      headersDetalle:[
        {
          text: "ISBN",
          align: "left",
          sortable: true,
          value: "isbn"
        },{
          text: "Código inventario",
          align: "left",
          sortable: true,
          value: "codigo_inventario"
        },
        
        {
          text: "Edición",
          align: "left",
          sortable: true,
          value: "edicion"
        },
        {
          text: "Año de publicación",
          align: "left",
          sortable: true,
          value: "anio"
        },
        {
          text: "Existencia en bodega",
          align: "left",
          sortable: true,
          value: "existencia"
        },
        { text: "Acciones", value: "", sortable: false }
      ],
      headersAutores: [
      {
        text: "Id",
        align: "left",
        sortable: true,
        value: "id",
        hidden: true
      },
      {
        text: "Autor",
        align: "left",
        sortable: true,
        value: "nombres"
      },
      { text: "Acciones", value: "", sortable: false }
    ],

  }),
 
  created() {
   
  },

  mounted: function () {
    const that = this;
    that.getEditoriales();
    that.getCategorias();
    that.getAutores();
    that.AnioLibros();
  },
 
  computed: {
    computedHeadersAutores() {
      return this.headersAutores.filter(header => header.text !== "Id");
    },
   
  },
   
  methods: {
    async getEditoriales() {
      const that = this;
        Vue.axios.get(that.base_url+"/api/editorial/")
          .then(response => {
              that.editoriales = response.data.results;
          })
          .catch(error => {
            if (error.request.status === 401) {
              this.commit('removeToken');
              router.push("/login");
            }
          }
      );
    },
    goBack(){
      this.$router.push('libros');
    },
    deleteAutor(item){
      var index = this.autoresLibro.indexOf(item);
      this.autoresLibro.splice(index, 1);
    },
    deleteDetail(item){
      var index = this.librosDetalle.indexOf(item);
      this.librosDetalle.splice(index, 1);
    },

    validaForm(){
      let validacion = false;
      if(this.libro.titulo !=="" && this.libro.editorial !=="" && this.libro.categoria !==""){
        validacion = true;
      }
      else{
        validacion = false;
      }
      if(this.autoresLibro.length > 0){
        validacion = true;
      }
      else{
        validacion = false;
      }
      if( this.librosDetalle.length > 0){
        validacion = true;
      }
      else{
        validacion = false;
      }
      return validacion;
    },
    async getAutores() {
      const that = this;
        Vue.axios.get(that.base_url+"/api/autor/")
          .then(response => {
              response.data.results.forEach(element => {
                  element.nombre = element.nombres+" "+element.apellidos
              });
              that.autores = response.data.results;
          })
          .catch(error => {
            if (error.request.status === 401) {
              this.commit('removeToken');
              router.push("/login");
            }
          }
      );
    },
    async getCategorias() {
      const that = this;
        Vue.axios.get(that.base_url+"/api/categoria/")
          .then(response => {
              that.categorias = response.data.results;
          })
          .catch(error => {
            if (error.request.status === 401) {
              this.commit('removeToken');
              router.push("/login");
            }
          }
      );
    },
    
    addAutor(autor){
      this.autoresLibro.push({id: autor.id, nombres:autor.nombre});
      this.comboAutor = "";
    },
    addDetalleLibro(){
      var copia = {
        isbn: this.libro.isbn,
        codigo_inventario: this.libro.codigo_inventario,
        existencia: this.libro.existencia,
        edicion: this.libro.edicion.edicion,
        anio: this.libro.anio.anio,
      }
      this.librosDetalle.push(copia);
      this.libro.codigo_inventario= "";
      this.libro.existencia= "";
      this.libro.edicion= "";
      this.libro.anio= "";
    },
    AnioLibros() {
      const that = this;
      var d = new Date();
      var añoActual = d.getFullYear();
      for (var i = 1940; i <= añoActual; i++) {
            that.anios.push({anio:i});
      }
    },
    async createLibro() {
      const that = this;
      if(that.validaForm()===true){
        let librodata = {};
        librodata ={
            titulo: that.libro.titulo,
            editorial : that.libro.editorial,
            categoria: that.libro.categoria,
            descripcion: "",
            autores: that.autoresLibro,
            detalle: that.librosDetalle
        }
        
        Vue.axios.post(that.base_url + "/api/libro/", librodata)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });

        this.loading = false;
        this.snackbar = true;
        this.text = "Libro almacenado con éxito";
        this.color = "success";
        this.$router.push('libros');
      }
      else{
        alert("Por favor ingresar todos los datos necesarios \n ->Datos de libro \n -> Autor o autores \n -> Detalle del libro(os) en inventario");
      }
      
    },
    
  }
};
</script>